
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AiConfigurationsCreateError": [
      "ArgumentError"
    ],
    "AiConfigurationsDeleteError": [
      "ArgumentError"
    ],
    "AiConfigurationsUpdateError": [
      "ArgumentError"
    ],
    "AiSandboxesCreateSessionError": [
      "ArgumentError"
    ],
    "AiSandboxesCreateSnapshotError": [
      "ArgumentError"
    ],
    "AiSandboxesCreateTemplateError": [
      "ArgumentError"
    ],
    "AiSandboxesDeleteTemplateError": [
      "ArgumentError"
    ],
    "AiSandboxesExecuteError": [
      "ArgumentError"
    ],
    "AiSandboxesRestoreSnapshotError": [
      "ArgumentError"
    ],
    "AiSandboxesResumeSessionError": [
      "ArgumentError"
    ],
    "AiSandboxesSuspendSessionError": [
      "ArgumentError"
    ],
    "AiSandboxesTerminateSessionError": [
      "ArgumentError"
    ],
    "AiSandboxesUpdateTemplateError": [
      "ArgumentError"
    ],
    "ApplicationDocumentUnion": [
      "ApplicationTemplate",
      "ApplicationTemplateEnvironmentVariables"
    ],
    "ApplicationTemplatesCreateEnvironmentVariablesError": [
      "OperationError",
      "TemplateLineError"
    ],
    "ApplicationTemplatesCreateError": [
      "OperationError",
      "TemplateLineError"
    ],
    "AppsActivateError": [
      "ArgumentError"
    ],
    "AppsCloneError": [
      "ArgumentError"
    ],
    "AppsCreateError": [
      "ArgumentError"
    ],
    "AppsCreateServicesError": [
      "ArgumentError"
    ],
    "AppsDeleteError": [
      "ArgumentError"
    ],
    "AppsUpdateError": [
      "ArgumentError",
      "TemplateLineError"
    ],
    "AppsUpdateSettingsError": [
      "ArgumentError"
    ],
    "BuildArgsCreateError": [
      "ArgumentError"
    ],
    "BuildArgsDeleteError": [
      "ArgumentError"
    ],
    "BuildArgsUpdateError": [
      "ArgumentError"
    ],
    "BuildsCancelError": [
      "OperationError"
    ],
    "BuildsCreateError": [
      "ArgumentError"
    ],
    "BuildsRebuildError": [
      "OperationError"
    ],
    "ClaimerUnion": [
      "Environment",
      "User"
    ],
    "CloudIntegrationsCreateError": [
      "ArgumentError"
    ],
    "CloudIntegrationsDeleteError": [
      "ArgumentError"
    ],
    "CloudIntegrationsUpdateError": [
      "ArgumentError"
    ],
    "CloudResourceInterface": [
      "EcsCloudResource",
      "InstantDatasetCloudResource"
    ],
    "CloudSecretsAwsCreateError": [
      "OperationError"
    ],
    "CloudSecretsAwsCreateSsmError": [
      "OperationError"
    ],
    "CloudSecretsDeleteError": [
      "OperationError"
    ],
    "ClustersCreateError": [
      "ArgumentError"
    ],
    "ClustersDeleteError": [
      "ArgumentError"
    ],
    "ClustersGenerateKubeConfigDownloadUrlError": [
      "OperationError"
    ],
    "ClustersImportError": [
      "ArgumentError"
    ],
    "ClustersInstallKedaAddonError": [
      "OperationError"
    ],
    "ClustersInstallManagedAgentAddonError": [
      "OperationError"
    ],
    "ClustersLaunchError": [
      "ArgumentError"
    ],
    "ClustersPatchNodeGroupsError": [
      "OperationError"
    ],
    "ClustersRenewCertificateError": [
      "OperationError"
    ],
    "ClustersSetAllowedHostsError": [
      "OperationError"
    ],
    "ClustersSetDefaultError": [
      "OperationError"
    ],
    "ClustersToggleDatadogAgentError": [
      "OperationError"
    ],
    "ClustersUpgradeError": [
      "OperationError"
    ],
    "ClustersVerifyError": [
      "OperationError"
    ],
    "DatabaseID": [
      "AiConfiguration",
      "AiCredentialVault",
      "AiMemoryStore",
      "AiSandboxClass",
      "AiSandboxEvent",
      "AiSandboxExecution",
      "AiSandboxResource",
      "AiSandboxSession",
      "AiSandboxSnapshot",
      "AiSandboxTemplate",
      "AnthropicIntegration",
      "App",
      "ApplicationTemplate",
      "ApplicationTemplateEnvironmentVariables",
      "Artifact",
      "AuroraDatabase",
      "AuroraPool",
      "AzureFlexibleDatabase",
      "AzureFlexiblePool",
      "Build",
      "BuildArg",
      "CloudIntegration",
      "CloudProvider",
      "CloudSqlDatabase",
      "CloudSqlPool",
      "Cluster",
      "Customer",
      "CustomerSettings",
      "DatadogIntegration",
      "DeliveryInstallation",
      "DependencySchedule",
      "Domain",
      "EmailAddress",
      "Environment",
      "EnvironmentConfiguration",
      "EnvironmentConfigurationEnvironmentVariables",
      "EnvironmentDependencyGroup",
      "EnvironmentPipeline",
      "EnvironmentPipelineStage",
      "EnvironmentPreset",
      "EnvironmentPresetPool",
      "ExternalRegistry",
      "FileMount",
      "HuggingFaceIntegration",
      "Identity",
      "IdentityProvider",
      "Initiation",
      "Invite",
      "LangfuseIntegration",
      "Log",
      "Namespace",
      "NeonDatabase",
      "NeonIntegration",
      "NeonPool",
      "NodeGroup",
      "NvidiaIntegration",
      "OpenAiIntegration",
      "PlanetScaleDatabase",
      "PlanetScaleIntegration",
      "PlanetScalePool",
      "Pod",
      "PoolItem",
      "PresetTemplate",
      "ProjectMapping",
      "PullRequest",
      "RdsDatabase",
      "RdsPool",
      "ReleaseInstallation",
      "Repository",
      "RepositoryAnalysis",
      "Role",
      "Secret",
      "Service",
      "SlackIntegration",
      "SshKey",
      "SupabaseDatabase",
      "SupabaseIntegration",
      "SupabasePool",
      "Task",
      "TaskChain",
      "Usage",
      "User",
      "VercelIntegration",
      "WandbIntegration",
      "Workspace"
    ],
    "DatabaseInterface": [
      "AuroraDatabase",
      "AzureFlexibleDatabase",
      "CloudSqlDatabase",
      "NeonDatabase",
      "PlanetScaleDatabase",
      "RdsDatabase",
      "SupabaseDatabase"
    ],
    "DatabasePoolConfigurationInterface": [
      "AuroraPoolConfiguration",
      "AzureFlexiblePoolConfiguration",
      "CloudSqlPoolConfiguration",
      "NeonPoolConfiguration",
      "PlanetScalePoolConfiguration",
      "RdsPoolConfiguration",
      "SupabasePoolConfiguration"
    ],
    "DatabasePoolInterface": [
      "AuroraPool",
      "AzureFlexiblePool",
      "CloudSqlPool",
      "NeonPool",
      "PlanetScalePool",
      "RdsPool",
      "SupabasePool"
    ],
    "DatabasePoolSettingsProviderUnion": [
      "Cluster",
      "NeonDatasetConfiguration",
      "PlanetScaleDatasetConfiguration",
      "StandaloneDatasetConfiguration",
      "SupabaseDatasetConfiguration"
    ],
    "DatabaseSettingsProviderInterface": [
      "Cluster",
      "NeonDatasetConfiguration",
      "PlanetScaleDatasetConfiguration",
      "StandaloneDatasetConfiguration",
      "SupabaseDatasetConfiguration"
    ],
    "DatasetsCheckinError": [
      "OperationError"
    ],
    "DatasetsCheckoutError": [
      "OperationError"
    ],
    "DatasetsCreateError": [
      "ArgumentError"
    ],
    "DatasetsCreateStandaloneError": [
      "ArgumentError"
    ],
    "DatasetsRefreshError": [
      "OperationError"
    ],
    "DatasetsUpdateError": [
      "ArgumentError"
    ],
    "DependencySchedulesCreateError": [
      "ArgumentError"
    ],
    "DependencySchedulesDeleteError": [
      "OperationError"
    ],
    "DependencySchedulesUpdateError": [
      "ArgumentError"
    ],
    "DirectUploadsCreateError": [
      "OperationError"
    ],
    "DocumentInterface": [
      "ApplicationTemplate",
      "ApplicationTemplateEnvironmentVariables",
      "EnvironmentConfiguration",
      "EnvironmentConfigurationEnvironmentVariables"
    ],
    "DomainsCreateError": [
      "ArgumentError"
    ],
    "DomainsDeleteError": [
      "OperationError"
    ],
    "DomainsVerifyError": [
      "OperationError"
    ],
    "EchoError": [
      "OperationError"
    ],
    "EnvironmentConfigurationsCreateEnvironmentVariablesError": [
      "OperationError",
      "TemplateLineError"
    ],
    "EnvironmentConfigurationsCreateError": [
      "OperationError",
      "TemplateLineError"
    ],
    "EnvironmentDocumentUnion": [
      "EnvironmentConfiguration",
      "EnvironmentConfigurationEnvironmentVariables"
    ],
    "EnvironmentPipelinesAbortError": [
      "OperationError"
    ],
    "EnvironmentPresetsCreateError": [
      "ArgumentError"
    ],
    "EnvironmentPresetsDeleteEnvironmentVariableError": [
      "OperationError"
    ],
    "EnvironmentPresetsUpdateError": [
      "ArgumentError"
    ],
    "EnvironmentPresetsUpsertEnvironmentVariableError": [
      "OperationError"
    ],
    "EnvironmentsCreateError": [
      "ArgumentError",
      "EnvironmentsNoClusterAvailableError"
    ],
    "EnvironmentsCustomWorkflowError": [
      "OperationError",
      "PipelinesDeployCreationError",
      "PipelinesEnvironmentNotRunningError",
      "PipelinesEnvironmentNotSetupError",
      "PipelinesNoBuildFoundError"
    ],
    "EnvironmentsExtendError": [
      "OperationError"
    ],
    "EnvironmentsPatchError": [
      "OperationError",
      "PipelinesDeployCreationError",
      "PipelinesEnvironmentNotRunningError",
      "PipelinesNoBuildFoundError"
    ],
    "EnvironmentsPauseError": [
      "OperationError"
    ],
    "EnvironmentsResumeError": [
      "OperationError"
    ],
    "EnvironmentsSetupError": [
      "OperationError",
      "PipelinesDeployCreationError",
      "PipelinesEnvironmentNotRunningError",
      "PipelinesNoBuildFoundError"
    ],
    "EnvironmentsTeardownError": [
      "OperationError",
      "PipelinesDeployCreationError"
    ],
    "EnvironmentsUpdateAppImportsError": [
      "OperationError"
    ],
    "EnvironmentsUpdateSettingsError": [
      "ArgumentError"
    ],
    "ExternalRegistriesCreateError": [
      "ArgumentError"
    ],
    "ExternalRegistriesDeleteError": [
      "OperationError"
    ],
    "ExternalRegistriesUpdateError": [
      "ArgumentError"
    ],
    "FileMountsCreateError": [
      "ArgumentError"
    ],
    "FileMountsDeleteError": [
      "ArgumentError"
    ],
    "IdentitiesDeleteError": [
      "OperationError"
    ],
    "IdentityProvidersCreateError": [
      "ArgumentError"
    ],
    "InstalledIntegrationInterface": [
      "AnthropicIntegration",
      "DatadogIntegration",
      "HuggingFaceIntegration",
      "LangfuseIntegration",
      "NeonIntegration",
      "NvidiaIntegration",
      "OpenAiIntegration",
      "PlanetScaleIntegration",
      "SlackIntegration",
      "SupabaseIntegration",
      "VercelIntegration",
      "WandbIntegration"
    ],
    "IntegrationInterface": [
      "AnthropicIntegration",
      "AvailableIntegration",
      "DatadogIntegration",
      "HuggingFaceIntegration",
      "LangfuseIntegration",
      "NeonIntegration",
      "NvidiaIntegration",
      "OpenAiIntegration",
      "PlanetScaleIntegration",
      "SlackIntegration",
      "SupabaseIntegration",
      "VercelIntegration",
      "WandbIntegration"
    ],
    "IntegrationOwnerUnion": [
      "Workspace"
    ],
    "IntegrationsCreateAnthropicError": [
      "ArgumentError"
    ],
    "IntegrationsCreateDatadogError": [
      "ArgumentError"
    ],
    "IntegrationsCreateHuggingFaceError": [
      "ArgumentError"
    ],
    "IntegrationsCreateLangfuseError": [
      "ArgumentError"
    ],
    "IntegrationsCreateNeonError": [
      "ArgumentError"
    ],
    "IntegrationsCreateNvidiaError": [
      "ArgumentError"
    ],
    "IntegrationsCreateOpenAiError": [
      "ArgumentError"
    ],
    "IntegrationsCreatePlanetScaleError": [
      "ArgumentError"
    ],
    "IntegrationsCreateProjectMappingError": [
      "ArgumentError"
    ],
    "IntegrationsCreateSupabaseError": [
      "ArgumentError"
    ],
    "IntegrationsCreateVercelError": [
      "ArgumentError"
    ],
    "IntegrationsCreateWandbError": [
      "ArgumentError"
    ],
    "IntegrationsDeleteError": [
      "ArgumentError"
    ],
    "IntegrationsDeleteProjectMappingError": [
      "OperationError"
    ],
    "IntegrationsUpdateAnthropicError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateDatadogError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateHuggingFaceError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateLangfuseError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateNeonError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateNvidiaError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateOpenAiError": [
      "ArgumentError"
    ],
    "IntegrationsUpdatePlanetScaleError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateProjectMappingError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateSlackError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateSupabaseError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateVercelError": [
      "ArgumentError"
    ],
    "IntegrationsUpdateWandbError": [
      "ArgumentError"
    ],
    "InvitesAcceptError": [
      "ArgumentError"
    ],
    "InvitesCreateError": [
      "ArgumentError"
    ],
    "InvitesDeleteError": [
      "OperationError"
    ],
    "InvitesResendError": [
      "OperationError"
    ],
    "K8sResourcesStreamLogsError": [
      "OperationError"
    ],
    "LogsInterface": [
      "Build",
      "Cluster",
      "DeliveryInstallation",
      "PoolItem",
      "Task"
    ],
    "Node": [
      "AiConfiguration",
      "AiCredentialVault",
      "AiMemoryStore",
      "AiSandboxClass",
      "AiSandboxEvent",
      "AiSandboxExecution",
      "AiSandboxResource",
      "AiSandboxSession",
      "AiSandboxSnapshot",
      "AiSandboxTemplate",
      "AnthropicIntegration",
      "App",
      "ApplicationTemplate",
      "ApplicationTemplateEnvironmentVariables",
      "Artifact",
      "AuroraDatabase",
      "AuroraPool",
      "AvailableIntegration",
      "AzureFlexibleDatabase",
      "AzureFlexiblePool",
      "Build",
      "BuildArg",
      "CloudIntegration",
      "CloudProvider",
      "CloudSqlDatabase",
      "CloudSqlPool",
      "Cluster",
      "Customer",
      "CustomerSettings",
      "DatadogIntegration",
      "DeliveryInstallation",
      "DependencySchedule",
      "Domain",
      "EmailAddress",
      "Environment",
      "EnvironmentConfiguration",
      "EnvironmentConfigurationEnvironmentVariables",
      "EnvironmentDependencyGroup",
      "EnvironmentPipeline",
      "EnvironmentPipelineStage",
      "EnvironmentPreset",
      "EnvironmentPresetPool",
      "ExternalRegistry",
      "FileMount",
      "HuggingFaceIntegration",
      "Identity",
      "IdentityProvider",
      "Initiation",
      "Invite",
      "LangfuseIntegration",
      "Log",
      "Namespace",
      "NeonDatabase",
      "NeonIntegration",
      "NeonPool",
      "NodeGroup",
      "NvidiaIntegration",
      "OpenAiIntegration",
      "PlanetScaleDatabase",
      "PlanetScaleIntegration",
      "PlanetScalePool",
      "Pod",
      "PoolItem",
      "ProjectMapping",
      "PullRequest",
      "RdsDatabase",
      "RdsPool",
      "ReleaseInstallation",
      "Repository",
      "RepositoryAnalysis",
      "Role",
      "Secret",
      "Service",
      "SlackIntegration",
      "SshKey",
      "SupabaseDatabase",
      "SupabaseIntegration",
      "SupabasePool",
      "Task",
      "TaskChain",
      "User",
      "VercelIntegration",
      "VercelProject",
      "WandbIntegration",
      "Workspace"
    ],
    "NodeGroupsCreateError": [
      "ArgumentError"
    ],
    "NodeGroupsDeleteError": [
      "OperationError"
    ],
    "NodeGroupsUpdateError": [
      "ArgumentError"
    ],
    "OrganizationsFindOrCreateError": [
      "ArgumentError"
    ],
    "PaymentsGenerateUrlError": [
      "ArgumentError"
    ],
    "PaymentsValidateError": [
      "ArgumentError"
    ],
    "PipelineInterface": [
      "EnvironmentPipeline"
    ],
    "PoolInterface": [
      "AuroraPool",
      "AzureFlexiblePool",
      "CloudSqlPool",
      "EnvironmentPresetPool",
      "NeonPool",
      "PlanetScalePool",
      "RdsPool",
      "SupabasePool"
    ],
    "PoolableUnion": [
      "AuroraDatabase",
      "AzureFlexibleDatabase",
      "CloudSqlDatabase",
      "EnvironmentPreset",
      "NeonDatabase",
      "PlanetScaleDatabase",
      "RdsDatabase",
      "SupabaseDatabase"
    ],
    "PoolsDeleteError": [
      "OperationError"
    ],
    "PrimaryLinksCreateError": [
      "ArgumentError"
    ],
    "PrimaryLinksDeleteError": [
      "ArgumentError"
    ],
    "ProjectInterface": [
      "VercelProject"
    ],
    "ReleaseInstallationsRegisterError": [
      "ArgumentError"
    ],
    "SecretsCreateError": [
      "ArgumentError"
    ],
    "SecretsDeleteError": [
      "OperationError"
    ],
    "SecretsUpdateError": [
      "ArgumentError"
    ],
    "ServicesUpdateError": [
      "ArgumentError"
    ],
    "SshKeysCreateError": [
      "ArgumentError"
    ],
    "SshKeysDeleteError": [
      "OperationError"
    ],
    "UserError": [
      "ArgumentError",
      "EnvironmentsNoClusterAvailableError",
      "OperationError",
      "PipelinesDeployCreationError",
      "PipelinesEnvironmentNotRunningError",
      "PipelinesEnvironmentNotSetupError",
      "PipelinesNoBuildFoundError",
      "TemplateLineError"
    ],
    "UsersGenerateAuthenticationTokenError": [
      "OperationError"
    ],
    "UsersLogoutError": [
      "OperationError"
    ],
    "UsersUpdateProfileError": [
      "ArgumentError"
    ],
    "UsersUpdateSettingsError": [
      "ArgumentError"
    ],
    "WorkspacesApplyPromoCodeError": [
      "ArgumentError"
    ],
    "WorkspacesAttachIdentityError": [
      "OperationError"
    ],
    "WorkspacesCreateError": [
      "ArgumentError"
    ],
    "WorkspacesDeleteMemberError": [
      "OperationError"
    ],
    "WorkspacesDetachIdentityError": [
      "OperationError"
    ],
    "WorkspacesUpdateError": [
      "ArgumentError"
    ],
    "WorkspacesUpdateSettingsError": [
      "ArgumentError"
    ],
    "WorkspacesUpdateUserRoleError": [
      "OperationError"
    ]
  }
};
      export default result;
    